import RejectedApplications from "../Administration/RejectedApplications";

const PwdRejectedApplications = ({ role }) => {
  return (
    <>
      <RejectedApplications role={role} />
    </>
  );
};

export default PwdRejectedApplications;
